<template>
  <vs-card class="px-2 py-6 text-center">
    <i class="fal fa-10x fa-frown text-gray-light pt-10"></i>
    <div class="text-xl py-6 text-gray">Désolé, aucune donnée à afficher pour l'instant</div>
  </vs-card>
</template>

<script>
export default {
  name: 'EmptyCard'
}
</script>